const SkeletonSpeed = 2;

export default SkeletonSpeed;
